export { default } from './ShipmentPrescriptionContentsList'
